// extracted by mini-css-extract-plugin
module.exports = {"text":"AddShoppingListToCart_text__mEOsv"};